import { connect } from 'react-redux'
import pick from 'lodash/pick'

import Settings from '../../components/settings/settings'
import {
  updateEmailPreferences,
  updateDesktopPreferences
 } from '../../actions/settings'

const mapStateToProps = (state, props) => {
  const { email, userName } = pick(state.auth.session, ['email', 'userName'])

  return {
    email,
    userName,
  }
}

const mapDispatchToProps = (dispatch, props) => {
  return {
    updateEmailPreference (data) {
      dispatch(updateEmailPreferences(data))
    },

    updateDesktopPreference (data) {
      dispatch(updateDesktopPreferences(data))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings)



// WEBPACK FOOTER //
// ./src/containers/settings/settings-container.js